export const STORE_API_FIELD_BINDINGS = 'ApiFieldBindingsUI';
export type STORE_API_FIELD_BINDINGS = typeof STORE_API_FIELD_BINDINGS;

export const STORE_API_FIELD_BINDINGS_PREVIEW = 'ApiFieldBindingsPreviewUI';
export type STORE_API_FIELD_BINDINGS_PREVIEW = typeof STORE_API_FIELD_BINDINGS_PREVIEW;
